import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=ff8a5436&scoped=true&"
var script = {}
import style0 from "./foot.vue?vue&type=style&index=0&id=ff8a5436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8a5436",
  null
  
)

export default component.exports